import script from "./AppFloatingIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppFloatingIcon.vue?vue&type=script&setup=true&lang=ts"

import "./AppFloatingIcon.vue?vue&type=style&index=0&id=2faeb4ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2faeb4ac"]])

export default __exports__